<div>
  <div *ngIf="paymentSource && !inputNewCard">
    <div class="property">
      <label>Payment Method</label>
      <div>
        Membership Card ({{ paymentSource.brand }} ** {{ paymentSource.last4 }})
        <br/>
        <button style="margin-top: 0.5em;" mat-raised-button type="button" (click)="inputNewCard = true" matTooltip="Enter new credit card details">Change</button>
      </div>
    </div>

  </div>

  <div class="credit-card-form" *ngIf="inputNewCard">
    <ng-container *ngIf="paymentSource && inputNewCard">
      <div class="actions">
        <button mat-raised-button color="primary" type="button" (click)="inputNewCard = false">
          Use {{ paymentSource.brand }} **** {{ paymentSource.last4 }}
        </button>
      </div>
      <br/>
    </ng-container>
    
    <app-form #form class="credit-card-form" [class.script-off]="false" action="/gift" [handler]="this">
            
      <div class="form-payment">
        <div class="card-payment">
          <error-message></error-message>
    
          <mat-form-field>
            <mat-label>Cardholder Name</mat-label>
            <input matInput errorHighlight 
              type="text"
              id="cardholder-name" name="cardholder-name" 
              [(ngModel)]="cardholderName"
              required>
          </mat-form-field>
          
          <mat-form-field>
            <mat-label>Credit Card Number</mat-label>
            <input #ccElement 
              matInput
              errorHighlight 
              type="text" 
              id="cc-number" 
              name="cc-number" 
              autocomplete="cc-number"
              (change)="updateCardBrand()" 
              (keyup)="updateCardBrand()" 
              [(ngModel)]="creditCard" 
              />
          </mat-form-field>
    
          <div class="card-exp-cvc">
    
            <mat-form-field class="expiration">
              <mat-label>Expiration</mat-label>
              <input 
                matInput 
                errorHighlight 
                type="text" 
                placeholder="MM/YYYY" 
                name="cc-exp" 
                [(ngModel)]="expiration" 
                required
                />
            </mat-form-field>
            <mat-form-field class="cvc">
              <mat-label>CVC</mat-label>
              <input 
                matInput 
                errorHighlight 
                type="text" 
                name="cc-csc" 
                [(ngModel)]="cvc" 
                required 
                placeholder="CVC"
                />
            </mat-form-field>
            <a href="https://www.cvvnumber.com/cvv.html" target="_blank" class="card-tooltip">What is this?
              <span class="tooltiptext">
                The CVV Number ("Card Verification Value") on your credit card or debit card is a 3 digit number on VISA®, MasterCard® and
                Discover® branded credit and debit cards. On your American Express® branded credit or debit card it is a 4 digit
                numeric code.
              </span>
            </a>
          </div>
    
          <div *ngIf="newCardMessage" class="alert alert-warning">
            <strong>Important:</strong> 
            {{newCardMessage}}
          </div>
        </div>
    
        <!-- <div class="edit-email-btns">
          <app-form-submit-button type="button">Apply</app-form-submit-button>
          <a href="javascript:;" (click)="inputNewCard = false">cancel</a>
        </div> -->

        <!-- <button *ngIf="!submitting" type="submit" class="btn">Update Billing Info</button>
        <button type="button" (click)="cancelUpdateInfo()" *ngIf="!submitting" class="btn cancel">Cancel</button> -->
      </div>
    
    </app-form>

    <div *ngIf="validityError" class="alert alert-danger">
      <strong>An issue occurred processing your request. Please check the information above.</strong>
      <ul>
        <li>Ensure your credit card details are correct.</li>
        <li>Gifts cannot currently be sent to existing TYT members.</li>
        <li>Ensure that your email and the recipient email are correct.</li>
      </ul>
    </div>

    <error-message [producer]="this"></error-message> <!-- for API errors, etc -->
  </div>
</div>